// NOTE: This red "badger" would be better implemented as a component.
/**
 * Returns data source pill text(red box on the right side of practitioners name) by practitioner
 *
 * @param {any} practitioner - practitioner object used to return the text
 * @returns {string} - text to be displayed on the red box
 * @example
 * let dataSourcePillText = getDataSourcePillText(practitioner);
 */
export const getDataSourcePillText = (practitioner: any) => {
  let dataSourcePillText: string | null = null;

  switch (practitioner.data_source) {
    case "PRACTITIONER_ACCOUNT_VIEW":
      dataSourcePillText = null; // no pill for this case
      break;
    case "PRACTITIONER_ACCOUNT_VIEW_NM":
      dataSourcePillText = "Badger";
      break;
    case "PRACTITIONER_DISTRIBUTOR_ACCOUNT_VIEW":
      switch (practitioner.name_dfh_channel) {
        case "":
          dataSourcePillText = `Dist`;
          break;
        case "DFH":
          dataSourcePillText = `Dist: ${practitioner.name_dfh_channel}`;
          break;
        default:
          dataSourcePillText = `${practitioner.name_dfh_channel}`;
          break;
      }
      break;
    default:
      dataSourcePillText = null;
  }
  return dataSourcePillText;
}